<!--出库任务 - 编辑--->
<template>
  <WarehouseOutDetail></WarehouseOutDetail>
</template>

<script>
import WarehouseOutDetail from './WarehouseOutDetail'
export default {
  components: {
    WarehouseOutDetail
  },
  data () {
    return {

    }
  },
  mounted () {

  },
  methods: {

  },
  computed: {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/assignmentManage/warehouse/WarehouseOutEdit.vue